import React, { useEffect, useState } from 'react';
import LoadingIndicator from './LoadingIndicator';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';

type EventNames = 'openMissionApplicationModal';

interface Props {
  id?: string;
  url?: string;
  className?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  eventHandlers?: Record<EventNames, (data: any) => void>;
}

const useStyles = createUseStyles({
  iframe: {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    position: 'relative',
    zIndex: 2,
  },
});

const PlatformV2Iframe = (props: Props) => {
  const { url, id } = props;
  const [isLoading, setIsLoading] = useState(true);
  const styles = useStyles();
  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  useEffect(() => {
    const listener = (event: MessageEvent) => {
      const { data } = event;
      const eventHandlers = props.eventHandlers;
      const { name, payload } = data as { name: EventNames; payload: unknown };
      if (eventHandlers && eventHandlers[name]) {
        eventHandlers[name](payload);
      }
    };

    window.addEventListener('message', listener);

    return () => {
      window.removeEventListener('message', listener);
    };
  }, []);

  return (
    <>
      {isLoading && <LoadingIndicator loading={isLoading} />}
      {url && (
        <iframe
          id={id}
          title={id}
          frameBorder={0}
          src={url}
          className={classNames(styles.iframe, props.className)}
          onLoad={handleIframeLoad}
          allow="camera; microphone"
          {...{ 'data-testid': id || 'iframe' }}
        />
      )}
    </>
  );
};

export default PlatformV2Iframe;
